import { t } from '@lingui/macro';
import { mimeTypeToUserFriendlyString } from 'utils/file/MIMETypeUtils';
import { useItemHandleFragment$data } from './__generated__/useItemHandleFragment.graphql';

export const useItemTypeDescription = (item: useItemHandleFragment$data) => {
  switch (item.__typename) {
    case 'Folder':
      return t`Folder`;
    case 'FolderItem':
    case 'AnnouncementAttachment':
    case 'MemberDetailsAttachment':
      switch (item.content?.__typename) {
        case 'Page':
          return t`Document`;
        case 'File':
          return mimeTypeToUserFriendlyString(item.content.mimeType);
        case 'PendingFile':
          return t`Pending file`;
        case 'Form':
          return t`Form`;
        case 'InternalBridge':
        case 'ExternalBridge':
          return t`Bridge`;
      }
      break;
    case 'VaultItem':
      switch (item.content?.__typename) {
        case 'PendingFile':
          return t`Pending file`;
        case 'File':
          return mimeTypeToUserFriendlyString(item.content.mimeType);
        default:
          return t`Vault item`;
      }
    case 'Vault':
      return t`Vault`;
    case 'Event':
      return t`Event`;
    case 'Member':
      return t`Member`;
    case 'Space':
      return t`Space`;
    case 'Announcement':
      return t`Announcement`;
  }
  return t`Unknown`;
};
